import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { setGlobalSessionPopupTrigger } from '../services/authService';
import logger from '../utils/logger.js';
import { MAP_VIEW_PATH, isGraphViewRoutePath } from '../constants/routes.js';
import { hasGraphViewPermissions } from '../utils/utils.jsx';

const PrivateRoute = ({ children }) => {
    const { user, triggerSessionExpiredPopup } = useAuth();
    const location = useLocation();
    const isGraphRouteBlocked = Boolean(user) && isGraphViewRoutePath(location.pathname) && !hasGraphViewPermissions(user?.role);
    useEffect(() => {
        if (!user) {
            logger.info("user not authenticated,redirecting to login");
        }
    }, [user]);
    useEffect(() => {
        setGlobalSessionPopupTrigger(triggerSessionExpiredPopup);
    }, [triggerSessionExpiredPopup]);
    if (!user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    if (isGraphRouteBlocked) {
        return <Navigate to={MAP_VIEW_PATH} replace />;
    }

    return children;
}
export default PrivateRoute;